<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Petty Cash Payments",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Petty Cash Payments",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Petty Cash Payments",
          active: true,
        },
      ],
      data: {
        name: "",
        quantity: "",
        amount: "",
        narration: "",
      },
      itemList: [],
    };
  },
  computed: {
    ...mapGetters("pettycash", ["getAllReqPettyCash", "SaveStatus"]),
    ...mapGetters("auth", ["getCurrentUser"]),
  },
  watch: {},
  methods: {
    ...mapActions({
      PettyCashAction: "pettycash/pettyCashAction",
      FetchAllRequestPettyCash: "pettycash/fetchAllRequestPettyCash",
    }),
    // COMMA SEPERTOR FUNCTION
    thousandSeperater(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    calculateSum(items) {
      return items.reduce((accumulator, object) => {
        return accumulator + object.quantity * object.amount;
      }, 0);
    },

    decline(id) {
      this.PettyCashAction({ status: 4, id });
    },

    approve(id) {
      this.PettyCashAction({ status: 2, id });
    },
  },
  created() {
    this.FetchAllRequestPettyCash();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('setting_sms')
        )
      "
    >
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="card-body row">
              <div class="col-md-12">
                <b-tabs content-class="p-3 text-muted">
                  <b-tab active class="border-0">
                    <template v-slot:title>
                      <span class="d-inline-block d-sm-none">
                        <i class="far fa-user"></i>
                      </span>
                      <span class="d-none d-sm-inline-block text-primary">
                        <b>
                          <i class="fa fa-list" aria-hidden="true"></i>
                          Approved Requests
                        </b>
                      </span>
                    </template>
                    <div class="row col-md-12">
                      <strong class="card-title-desc">Approved Requests</strong>
                      <div role="tablist">
                        <b-card
                          no-body
                          class="mb-1 shadow-none"
                          v-for="(
                            approvedPettyCash, index
                          ) in getAllReqPettyCash.approved"
                          :key="index"
                        >
                          <b-card-header header-tag="header" role="tab">
                            <h6 class="m-0">
                              <div
                                v-b-toggle="'accordion-' + approvedPettyCash.id"
                                class="text-dark"
                                href="javascript: void(0);"
                              >
                                Requested By:
                                <b>{{ approvedPettyCash.user.name }}</b> |
                                Amount:
                                <b>{{
                                  calculateSum(approvedPettyCash.petty_items)
                                }}</b>
                                | Date:
                                <b>{{ approvedPettyCash.request_date }}</b>

                                <b-button-group class="float-end">
                                  <router-link
                                    :to="
                                      '/petty/payments/' + approvedPettyCash.id
                                    "
                                    role="button"
                                    class="btn btn-sm btn-success"
                                  >
                                    <i
                                      class="fa fa-check-circle"
                                      aria-hidden="true"
                                    ></i>
                                    Make Payment
                                  </router-link>
                                </b-button-group>
                              </div>
                            </h6>
                          </b-card-header>
                          <b-collapse
                            :id="'accordion-' + approvedPettyCash.id"
                            accordion="my-accordion"
                            role="tabpanel"
                          >
                            <b-card-body>
                              <b-card-text>
                                <table class="table mt-2">
                                  <thead>
                                    <tr>
                                      <th scope="col">#</th>
                                      <th scope="col">Name</th>
                                      <th scope="col">Amount</th>
                                      <th scope="col">Quantity</th>
                                      <th scope="col">Total</th>
                                      <th scope="col">Narration</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr
                                      v-for="(
                                        pettyItem, petttyIndex
                                      ) in approvedPettyCash.petty_items"
                                      :key="petttyIndex"
                                    >
                                      <th scope="row">{{ petttyIndex + 1 }}</th>
                                      <td>{{ pettyItem.name }}</td>
                                      <td>{{ pettyItem.amount }}</td>
                                      <td>{{ pettyItem.quantity }}</td>
                                      <td>
                                        {{
                                          thousandSeperater(
                                            pettyItem.amount *
                                              pettyItem.quantity
                                          )
                                        }}
                                      </td>
                                      <td>
                                        <p>{{ pettyItem.narration }}</p>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </b-card-text>
                            </b-card-body>
                          </b-collapse>
                        </b-card>
                      </div>
                    </div>
                  </b-tab>
                  <b-tab>
                    <template v-slot:title>
                      <span class="d-inline-block d-sm-none">
                        <i class="far fa-user"></i>
                      </span>
                      <span class="d-none d-sm-inline-block text-success">
                        <b>
                          <i class="fa fa-list" aria-hidden="true"></i> Paid
                          Requests
                        </b>
                      </span>
                    </template>
                    <div class="row col-md-12">
                      <strong class="card-title-desc">Paid Requests</strong>
                      <div role="tablist">
                        <b-card
                          no-body
                          class="mb-1 shadow-none"
                          v-for="(
                            paidPettyCash, index
                          ) in getAllReqPettyCash.paid"
                          :key="index"
                        >
                          <b-card-header header-tag="header" role="tab">
                            <h6 class="m-0">
                              <div
                                v-b-toggle="'accordion-' + paidPettyCash.id"
                                class="text-dark"
                                href="javascript: void(0);"
                              >
                                Requested By:
                                <b>{{ paidPettyCash.user.name }}</b> | Amount:
                                <b>{{
                                  calculateSum(paidPettyCash.petty_items)
                                }}</b>
                                | Date:
                                <b>{{ paidPettyCash.request_date }}</b>

                                <strong
                                  v-if="paidPettyCash.status == 1"
                                  class="text-primary float-end"
                                  >Pending</strong
                                ><strong
                                  v-else-if="paidPettyCash.status == 2"
                                  class="text-success float-end"
                                  >Apprved</strong
                                >
                                <strong
                                  v-else-if="paidPettyCash.status == 3"
                                  class="text-success float-end"
                                  >Paid Off</strong
                                >
                                <strong
                                  v-else-if="paidPettyCash.status == 4"
                                  class="text-danger float-end"
                                  >Declined</strong
                                >
                                <!-- <br />
                                <hr />
                                <a
                                  name=""
                                  id=""
                                  class="btn btn-sm btn-danger float-end"
                                  href="#"
                                  role="button"
                                  >Withdraw</a
                                > -->
                              </div>
                            </h6>
                          </b-card-header>
                          <b-collapse
                            :id="'accordion-' + paidPettyCash.id"
                            accordion="my-accordion"
                            role="tabpanel"
                          >
                            <b-card-body>
                              <b-card-text>
                                <table class="table mt-2">
                                  <thead>
                                    <tr>
                                      <th scope="col">#</th>
                                      <th scope="col">Name</th>
                                      <th scope="col">Amount</th>
                                      <th scope="col">Quantity</th>
                                      <th scope="col">Total</th>
                                      <th scope="col">Narration</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr
                                      v-for="(
                                        pettyItem, petttyIndex
                                      ) in paidPettyCash.petty_items"
                                      :key="petttyIndex"
                                    >
                                      <th scope="row">{{ petttyIndex + 1 }}</th>
                                      <td>{{ pettyItem.name }}</td>
                                      <td>{{ pettyItem.amount }}</td>
                                      <td>{{ pettyItem.quantity }}</td>
                                      <td>
                                        {{
                                          thousandSeperater(
                                            pettyItem.amount *
                                              pettyItem.quantity
                                          )
                                        }}
                                      </td>
                                      <td>
                                        <p>{{ pettyItem.narration }}</p>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </b-card-text>
                            </b-card-body>
                          </b-collapse>
                        </b-card>
                      </div>
                    </div>
                  </b-tab>
                </b-tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
